<template>
  <div class="aboutUs">
    <ListTitle :title="title" :titleImg="titleImg" h />
    <v-container class="py-12">
      <v-row>
        <v-col>
          <NoticeContent :tree="false" :bgColor="'rgba(255,255,255,0.7)'">
            <div v-html="TOOL.replaceUnitToRem(data.Content)" />
          </NoticeContent>
        </v-col>
      </v-row>
    </v-container>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/layouts/footer.vue";
import ListTitle from "@/components/ui/searchList/ListTitle.vue";
import NoticeContent from "@/components/home/section2/NoticeContent.vue";
export default {
  props: {
    title: {
      type: String,
      default: "關於我們"
    },
    titleImg: {
      type: String,
      default: "common/icon_aboutUs.svg"
    }
  },
  components: {
    Footer,
    NoticeContent,
    ListTitle
  },
  data() {
    return {
      data: {
        Content: ""
      }
    };
  },
  mounted() {
    this.data = this.$store.state.announce.aboutUs;
    if (this.data.Content === "") {
      this.$store.dispatch("getAboutUs").then(() => {
        this.data = this.$store.state.announce.aboutUs;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.aboutUs {
  background-color: #f6edd9;
  @include pcAndpad {
    min-height: 100vh;
  }
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  background-position: 50% 50%;
  background-image: url("~@/assets/images/home/sect4_bg.png");
  background-attachment: fixed;
}
p:before {
  content: "\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0";
}
</style>
